<!-- Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. -->

<h1>{{ appStrings.LOG_IN }}</h1>
<form class="core-container-content" [formGroup]="signUpForm" (ngSubmit)="save()">
	<mat-form-field>
		<mat-label>{{ appStrings.EMAIL }}</mat-label>
		<input matInput autocomplete="username" formControlName="email" />
		<mat-error>{{ appStrings.ENTER_VALID_EMAIL }}</mat-error>
	</mat-form-field>
	<button-footer
		class="mat-form-field-compatible-spacing"
		[disabled]="!signUpForm.valid"
		[saveOrCloseButtonText]="appStrings.WIZARD_CONTINUE"
	>
	</button-footer>
</form>

<div class="mat-form-field-compatible-spacing" *ngIf="!(isSSO$ | async)">
	{{ appStrings.NEW_TO_TOUCHPLAN }}
	<a [routerLink]="'../signup-validation'" queryParamsHandling="preserve">{{ appStrings.SIGN_UP }}</a>
</div>
<!-- the static link to mobile production could probably be better-->
<div *ngIf="!isMobile; else mobileQuery" class="mat-form-field-compatible-spacing">
	{{ appStrings.PHONE_QUERY }} <a href="https://m.touchplan.io">{{ appStrings.MOBILE_REDIRECT }}</a>
</div>
<ng-template #mobileQuery>
	<div class="mat-form-field-compatible-spacing">
		{{ appStrings.DESKTOP_QUERY }} <a href="https://touchplan.io">{{ appStrings.DESKTOP_REDIRECT }}</a>
	</div>
</ng-template>
<div *ngIf="!(isRallyRoute$ | async)" class="access-code-enter-btn-container">
	<button [routerLink]="'../rally'" mat-raised-button class="access-code-enter-btn">
		{{ appStrings.ACCESS_CODE_ENTER_CODE_TITLE_CASE }}
	</button>
</div>
